export interface AcousticConfig {
  freqs: number[];
  bitsPerSymbol: number;
  baudRate: number;
  sampleRate: number;
  bufferSize: number;
  maxPayload: number;
  preamble: number[];
  syncWord: number[];
  endWord: number[];
  magnitudeRatio: number;
  minMagnitude: number;
  preambleMinCycles: number;
  preambleMaxErrors: number;
  guardRatio: number;
  fadeTime: number;
}

export const defaultConfig: AcousticConfig = {
  freqs: [1200, 1600, 2000, 2400],
  bitsPerSymbol: 2,
  baudRate: 20,
  sampleRate: 48000,
  bufferSize: 2048,
  maxPayload: 1024,
  preamble: [0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3],
  syncWord: [3, 3, 0, 0],
  endWord: [3, 0, 3, 0],
  magnitudeRatio: 1.5,
  minMagnitude: 3.0,
  preambleMinCycles: 6,
  preambleMaxErrors: 2,
  guardRatio: 0.2,
  fadeTime: 0.01,
};

export type ReceiverState =
  | 'idle'
  | 'calibrating'
  | 'listening'
  | 'preamble'
  | 'sync'
  | 'receiving'
  | 'complete'
  | 'error';
